module.exports = __webpack_public_path__ + "img/ac_logo_solid.999a660f.png";